'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'fad';
var iconName = 'mobile';
var width = 384;
var height = 512;
var aliases = [128241, "mobile-android", "mobile-phone"];
var unicode = 'f3ce';
var svgPathData = ['M368 384H16v64c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V384zM160 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z', 'M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z'];
exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData]
};
exports.faMobile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;